<template>
  <b-notification :has-icon="true" icon="database" :closable="false">
    <span v-html="$t('compCarbonFormsHelpFileFormat.info-1')" />
    <b-icon icon="plus" size="is-small" /> {{ $t('add').toLowerCase() }}
    <span v-html="$t('compCarbonFormsHelpFileFormat.info-2')" />
    <b-icon icon="upload" size="is-small" />
    {{ $t('compCarbonFormsHelpFileFormat.uploaded') }}
    <span v-html="$t('compCarbonFormsHelpFileFormat.info-3')" />
    <a class="link" @click="displayFormat = true">
      {{ $t('compCarbonFormsHelpFileFormat.info-4') }}</a
    >
    <span v-html="$t('compCarbonFormsHelpFileFormat.info-5')" />
    <br v-if="hasExtraction" />
    <span v-if="hasExtraction">
      {{ $t('compCarbonFormsHelpFileFormat.info-11') }}
      <a class="link" @click="displayExtraction = true">{{
        $t('compCarbonFormsHelpFileFormat.info-12')
      }}</a>
      {{ $t('compCarbonFormsHelpFileFormat.info-13') }}
    </span>

    <b-modal :active.sync="displayFormat" has-modal-card>
      <div class="modal-card" style="width: 900px; height: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsHelpFileFormat.title-1') }}
          </p>
        </header>
        <section class="modal-card-body">
          <component :is="formatImportName" />
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="displayExtraction" has-modal-card :width="900">
      <div class="modal-card" style="width: 900px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsHelpFileFormat.title-2') }}
          </p>
        </header>
        <section class="modal-card-body">
          <component :is="extractionImportName" />
        </section>
      </div>
    </b-modal>
  </b-notification>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'HelpFileFormat',
  props: {
    module: {
      type: String,
      required: true
    },
    hasExtraction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      error: null,
      displayFormat: false,
      displayExtraction: false
    }
  },
  computed: {
    formatImportName: function () {
      return this.module + 'HelpFileFormat'
    },
    extractionImportName: function () {
      return this.module + 'HelpFileExtraction'
    }
  },
  beforeMount () {
    Vue.component(
      this.formatImportName,
      // A dynamic import returns a Promise.
      () =>
        import(
          '@/components/carbon/forms/' + this.module + '/HelpFileFormat.vue'
        )
    )
    if (this.hasExtraction) {
      Vue.component(
        this.extractionImportName,
        // A dynamic import returns a Promise.
        () =>
          import(
            '@/components/carbon/forms/' +
              this.module +
              '/HelpFileExtraction.vue'
          )
      )
    }
  }
}
</script>
